import { Component, OnInit } from '@angular/core';
import { HighlightService } from 'src/app/@core/services/highligh.service';

@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss']
})
export class TabsComponent implements OnInit {
  arrayComponent: any;
  componentRender: any;
  infoComponent: any;
  codeHtml: string;
  utils: any;
  highlighted: boolean = false;
  constructor(private highlightService: HighlightService) {
    this.utils = window.utils;

    this.infoComponent = {
      titulo: "Tabs",
      descripcion: "TABS"
    }
    this.codeHtml = `
    <div class="tabs-govco">			
        <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item">
            <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">Descripción</a>
            </li>
            <li class="nav-item">
            <a class="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false">Documentos</a>
            </li>
            <li class="nav-item">
            <a class="nav-link" id="messages-tab" data-toggle="tab" href="#messages" role="tab" aria-controls="messages" aria-selected="false">Medios de Pago</a>
            </li>
            <li class="nav-item">
            <a class="nav-link" id="settings-tab" data-toggle="tab" href="#settings" role="tab" aria-controls="settings" aria-selected="false">Puntos de Pago</a>
            </li>
        </ul>
            
        <div class="tab-content">
        <div class="tab-pane active" id="home" role="tabpanel" aria-labelledby="home-tab"><p>Pestaña Descripción, contenido HTML puede ser incluído aquí ...</p></div>
        <div class="tab-pane" id="profile" role="tabpanel" aria-labelledby="profile-tab"><p>Pestaña Documentos, contenido HTML puede ser incluído aquí ...</p></div>
        <div class="tab-pane" id="messages" role="tabpanel" aria-labelledby="messages-tab"><p>Pestaña Medios de Pago, contenido HTML puede ser incluído aquí ...</p></div>
        <div class="tab-pane" id="settings" role="tabpanel" aria-labelledby="settings-tab"><p>Pestaña Puntos de Pago, contenido HTML puede ser incluído aquí ...</p></div>
        </div>
    </div>`;
  }


  ngOnInit() {
    this.utils.init();
  }

  ngAfterViewChecked() {
    if (!this.highlighted) {
      this.highlightService.highlightAll();
      this.highlighted = true;
    }
  }

  ngAfterViewInit() {; 
  }

}





